import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import PlaceholderText from 'components/PlaceholderText';
import { PublishStatusCircle } from './styles';
import { getActivityLiveDetails } from 'builder/utils';
import messages from './messages';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { PUBLICATION_STATUS } from 'constants/constants';

const PublicationStatusCircle = (props) => {
  const { activityId, theme, setTooltip, handleMouseLeave, handleMouseEnter, circleRef } = props;
  const [status, setStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!activityId) return;
    const fetchActivityDetails = async () => {
      setIsLoading(true);
      try {
        const liveDetails = await getActivityLiveDetails(activityId);
        if (liveDetails?.pearsonPlusStatus) {
          setStatus(liveDetails?.pearsonPlusStatus);
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error("Error fetching activity live details:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchActivityDetails();
  }, [activityId]);

  const statusMapping = {
    [PUBLICATION_STATUS.IN_REVIEW]: { label: intl.formatMessage(messages.inReview), color: theme['color.magenta'] },
    [PUBLICATION_STATUS.PUBLISHED_LIVE]: { label: intl.formatMessage(messages.publishedLive), color: theme['color.green'] },
  };

  useEffect(() => {
    const currentStatus = statusMapping[status];
    if (currentStatus && currentStatus.label) {
      setTooltip((prev) => ({ ...prev, message: currentStatus.label }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  if (isLoading) {
    return <PlaceholderText height={10} minWidth={10} maxWidth={10} marginLeft={4} />;
  }

  if (!status || !statusMapping[status]) {
    return null;
  }

  const { color } = statusMapping[status];

  return (
    <PublishStatusCircle
      ref={circleRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      color={color}
    />
  );
};

PublicationStatusCircle.propTypes = {
  activityId: PropTypes.string,
  theme: PropTypes.object.isRequired,
};

export default PublicationStatusCircle;